"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ColumnBreak = exports.ResponsiveColumnBreak = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _useTheme = require("../hooks/useTheme");

var _ResponsiveColumn = require("./ResponsiveColumn");

var _ResponsiveGridContext = require("./ResponsiveGridContext");

var _ResponsiveGridMarkers = require("./ResponsiveGridMarkers");

var getClassNames = (0, _react.classNamesFunction)();
/**
 * A special type of column which provides a vertical line between other
 * columns.
 *
 * This pivots to a horizontal line when the grid `responsivePivot` threshold
 * is reached.
 */

var ResponsiveColumnBreakBase = function ResponsiveColumnBreakBase(_ref) {
  var className = _ref.className,
      styles = _ref.styles,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "styles"]);
  var theme = (0, _useTheme.useTheme)();

  var _useContext = (0, React.useContext)(_ResponsiveGridContext.ResponsiveGridContext),
      pivot = _useContext.pivot;

  var _getClassNames = getClassNames(styles, {
    theme: theme,
    pivot: pivot
  }),
      subComponentStyles = _getClassNames.subComponentStyles,
      classes = (0, _objectWithoutProperties2.default)(_getClassNames, ["subComponentStyles"]);

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponsiveColumn.ResponsiveColumn, (0, _objectSpread2.default)((0, _objectSpread2.default)({
    className: (0, _react.css)('ms-ResponsiveGrid--columnBreak', className),
    styles: subComponentStyles.column
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.separator
    })
  }));
};

var ResponsiveColumnBreak = (0, _react.styled)(ResponsiveColumnBreakBase, function (_ref2) {
  var palette = _ref2.theme.palette,
      pivot = _ref2.pivot;
  return {
    separator: [{
      flex: 'auto'
    }, !pivot ? {
      borderLeftWidth: '1px',
      borderLeftStyle: 'solid',
      borderLeftColor: palette.neutralTertiary,
      width: 0
    } : {
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: palette.neutralTertiary,
      height: 0
    }],
    subComponentStyles: {
      column: {
        root: [{
          flex: '0 0 1px'
        }, !pivot ? {
          alignItems: 'center',
          width: '1px'
        } : {
          justifyContent: 'center',
          height: '1px'
        }]
      }
    }
  };
});
exports.ColumnBreak = exports.ResponsiveColumnBreak = ResponsiveColumnBreak;

_ResponsiveGridMarkers.ResponsiveGridCellMarker.mark(ResponsiveColumnBreak);